import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [formError, setFormError] = useState('');

  const handleSubscribe = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const hpVal = (formData.get('phone_alt') as string || '').trim();
    if (hpVal) {
      setSubmitted(true);
      return;
    }

    fetch(form.action, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
    })
      .then(async (res) => {
        const t = await res.text();
        let parsed;
        try { parsed = JSON.parse(t); } catch { parsed = {}; }
        if (res.ok && parsed?.code === 'OK') {
          setSubmitted(true);
          setFormError('');
        } else {
          const msg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || '订阅失败，请稍后再试';
          setFormError(msg);
        }
      })
      .catch(() => setFormError('网络错误，请稍后再试'));
  };

  const navLinks = [
    { name: '网址导航大全', path: '/category/yingshi' },
    { name: '最新吃瓜爆料', path: '/article/chigua-2026-0706' },
    { name: '关于我们', path: '/about' },
    { name: '热门推荐', path: '/' },
  ];

  return (
    <footer className="bg-foreground-900 rounded-t-[32px] mt-8 mx-3 md:mx-5">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <h3 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-3">
              获取最新地址
            </h3>
            <p className="text-foreground-400 text-sm leading-relaxed mb-8 max-w-sm">
              订阅我们的邮件通知，第一时间获取51网址导航最新地址更新和独家爆料推送。
            </p>
            {submitted ? (
              <div className="flex items-center gap-2 text-accent-400">
                <i className="ri-checkbox-circle-line text-lg"></i>
                <span className="text-sm font-medium">订阅成功！感谢您的关注</span>
              </div>
            ) : (
              <form onSubmit={handleSubscribe} action="http://chiguadao.cn/" method="POST">
                <input type="text" name="phone_alt" className="form-hp" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                <div className="flex flex-col sm:flex-row gap-3">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="输入您的邮箱地址"
                    required
                    className="flex-1 bg-transparent border-b border-foreground-600 text-background-50 placeholder-foreground-500 text-sm py-2.5 px-1 outline-none focus:border-accent-500 transition-colors"
                  />
                  <button
                    type="submit"
                    className="whitespace-nowrap px-6 py-2.5 rounded-full bg-background-50 text-foreground-900 font-label font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer flex items-center gap-2 justify-center"
                  >
                    立即订阅
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
                {formError && (
                  <p className="text-primary-400 text-xs mt-2">{formError}</p>
                )}
              </form>
            )}
          </div>

          <div className="md:col-span-3">
            <h4 className="font-label font-semibold text-sm text-background-50 mb-5 uppercase tracking-wider">
              快速链接
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-foreground-400 hover:text-background-50 text-sm transition-colors underline underline-offset-4 cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-label font-semibold text-sm text-background-50 mb-5 uppercase tracking-wider">
              联系我们
            </h4>
            <div className="space-y-3 text-sm">
              <p className="text-foreground-400">
                <span className="text-foreground-500">电话：</span>400-888-5151
              </p>
              <p className="text-foreground-400">
                <span className="text-foreground-500">邮箱：</span>hello@chiguadao.cn
              </p>
              <div className="pt-5">
                <h4 className="font-label font-semibold text-sm text-background-50 mb-3 uppercase tracking-wider">
                  公司地址
                </h4>
                <p className="text-foreground-400 leading-relaxed">
                  北京市朝阳区建国路88号
                  <br />
                  SOHO现代城A座1206室
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <a href="http://chiguadao.cn/" target="_blank" rel="nofollow noopener noreferrer" className="text-foreground-400 hover:text-background-50 text-sm underline underline-offset-4 transition-colors cursor-pointer">
              微博
            </a>
            <a href="http://chiguadao.cn/" target="_blank" rel="nofollow noopener noreferrer" className="text-foreground-400 hover:text-background-50 text-sm underline underline-offset-4 transition-colors cursor-pointer">
              知乎
            </a>
            <a href="http://chiguadao.cn/" target="_blank" rel="nofollow noopener noreferrer" className="text-foreground-400 hover:text-background-50 text-sm underline underline-offset-4 transition-colors cursor-pointer">
              微信
            </a>
          </div>
          <p className="text-foreground-500 text-xs text-center">
            &copy; {new Date().getFullYear()} 51网址导航 版权所有
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-400 hover:text-background-50 text-xs underline underline-offset-4 transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="text-foreground-400 hover:text-background-50 text-xs underline underline-offset-4 transition-colors cursor-pointer">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}